import {
  transformFormData,
  type GetOrderListSearchResults,
} from "~/features/orders/common/DownloadOrderHistoryService/DownloadOrderHistoryService";
import { type OrderListSearchBoxData } from "~/features/orders/orderList/components/OrderListSearchBox/OrderListSearchBox";
import { getCurrentQuoteSearchAccount } from "~/domains/orders/quoteSearchUrlState";

/**
 * Quote account IDs are private and are therefore derived from the current account at execution time.
 * A multi-account subset is intentionally not restored from URL state after reload.
 */
export function prepareQuoteSearchRequest(formData: OrderListSearchBoxData): GetOrderListSearchResults {
  const selectedAccount = getCurrentQuoteSearchAccount();
  const requestData =
    formData.accounts?.length || !selectedAccount ? formData : { ...formData, accounts: [selectedAccount] };

  return transformFormData(requestData);
}
